/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Button, ButtonVariety, HelperText, Link, LinkHighlight } from '@sonarsource/echoes-react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { isStringDefined } from '~shared/helpers/types';
import { getGlobalSettingsUrl } from '~sq-server-commons/helpers/urls';
import { SlackIntegrationConfigurationCreation } from './SlackIntegrationConfigurationCreation';
import { useSlackAppManifestUrl } from './hooks';

export function SlackIntegrationNotConfigured() {
  const [isFormDisplayed, setIsFormDisplayed] = useState(false);

  const { isLoading: isLoadingSlackAppManifestUrl, slackAppManifestUrl } = useSlackAppManifestUrl();

  const onHideForm = () => {
    setIsFormDisplayed(false);
  };
  const onShowForm = () => {
    setIsFormDisplayed(true);
  };

  return isFormDisplayed && isStringDefined(slackAppManifestUrl) ? (
    <SlackIntegrationConfigurationCreation
      onHideForm={onHideForm}
      slackAppManifestUrl={slackAppManifestUrl}
    />
  ) : (
    <div className="sw-flex sw-items-center sw-gap-2">
      <Button
        isDisabled={!isStringDefined(slackAppManifestUrl)}
        isLoading={isLoadingSlackAppManifestUrl}
        onClick={onShowForm}
        variety={ButtonVariety.Default}
      >
        <FormattedMessage id="settings.instance_integrations.start_setup" />
      </Button>
      <HelperText>
        {!isLoadingSlackAppManifestUrl && slackAppManifestUrl === undefined ? (
          <FormattedMessage
            id="settings.slack.start_setup.no_server_base_url_warning"
            values={{
              link: (text) => (
                <Link highlight={LinkHighlight.Subtle} to={getGlobalSettingsUrl()}>
                  {text}
                </Link>
              ),
            }}
          />
        ) : (
          <FormattedMessage id="settings.slack.start_setup.hint" />
        )}
      </HelperText>
    </div>
  );
}
